/**
 * ReportFinancial entity class
 */
import moment from 'moment/moment'
import FileSaver from 'file-saver'

/**
 * ReportFinancialFactory
 * returns ReportFinancial entity class
 *
 * @class ReportFinancialFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportFinancial} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportFinancialFactory
 */
/* @ngInject */
export default function ReportFinancialFactory ($http, $injector, Report, onOffMixin, alertLiteSvc) {
  /* === ReportFinancial class === */

  /**
   * ReportFinancial model
   *
   * @class ReportFinancial
   * @classdesc ReportFinancial model
   * @memberof models
   * @see models
   * @extends models.Report
   * @mixes models.onOffMixin
   * @return {models.ReportFinancial} ReportFinancial entity
   */
  function ReportFinancial () {
    var obj = Report.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportFinancial.prototype = Object.create(Report.prototype)
  ReportFinancial.prototype.constructor = ReportFinancial

  /* === User instance methods & fields === */

  Object.assign(ReportFinancial.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ReportFinancial#
     * @type {Object}
     */
    _fields: { // autoPay: false,
      reportId: Number,
      name: String,
      status: String,
      createdTime: moment,
      createdBy: String,
      organizations: [],
      deleted: Boolean,
      fromDate: moment,
      toDate: moment,
      reportDetails:
        {
          from: moment,
          to: moment,
          reportName: String,
          periodCount: String,
          periodType: String,
          createdBy: String,
          purchaseItemCategories: [String],
          purchaseItemStatuses: [String],
          paymentSystemTypes: [String],
          paymentMethodTypes: [String],
          organizations: [{ name: String, organizationId: Number }],
          users: [String],
          convertedAfterTrialDays: Number,
          firstActivation: Boolean,
          autoPay: Boolean,
          reportType: String,
          withoutTrial: Boolean,
          subscriptionsFilter: {
            dailySubscriptionLength: { from: Number, to: Number },
            monthlySubscriptionLength: { from: Number, to: Number },
            names: [String]
          }
        }
    },

    /**
     * url template
     *
     * @memberof models.ReportFinancial#
     * @type {String}
     */
    _urlTemplate: 'api/report/financial/{{::reportId}}',

    /**
     * public url template
     *
     * @memberof models.ReportFinancial#
     * @type {String}
     */
    _publicUrlTemplate: '/report/financial/{{::reportId}}',

    /**
     * Download report file
     *
     * @memberof models.ReportFinancial#
     * @param type
     */
    _download (type) {
      $http.get(this._url + '\\download', {
        responseType: 'blob'
      }).then((response) => {
        FileSaver.saveAs(response.data, this.reportId + ' ' + moment(this.createdTime).format('DD-MM-YYYY HH-mm') + '.zip')
      })
    }
  }, onOffMixin)

  /* === ReportFinancial static methods & fields === */

  ReportFinancial.getSubscriptions = function () {
    return $http.get('/report/financial/extra')
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  /**
   * Search shows by param
   *
   * @param {String} url
   * @param {Object} params
   * @returns {Promise} promise
   */
  ReportFinancial.search = function (url, params) {
    return $http.post(url, { ...params })
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  /**
   * @typedef {Object} ReportFinancialExtra
   * @property {{id: number, name: string}[]} subscriptions
   * @property {Object.<string, string[]>} paymentSystem2PaymentMethods
   */
  /**
   * @type {ReportFinancialExtra}
   */

  ReportFinancial.extra = {
    subscriptions: [{ id: Number, name: String }],
    paymentSystem2PaymentMethods: null
  }

  // copy all static methods from Report class
  Object.assign(ReportFinancial, Report)
  ReportFinancial._name = 'ReportFinancial'
  ReportFinancial.init()

  // permissions
  // ReportFinancial.access = {
  //   view: 'viewReport',
  //   create: 'createReport',
  //   delete: 'deleteReport'
  // }

  return ReportFinancial
}
